const CJS_SCRIPT_ATTRIBUTE = 'data-profile-cjs-sdk';
const CJS_SCRIPT_TIMEOUT_MS = 10000;

const CJS_SCRIPT_URLS = {
  stg: 'https://swc-stg.autodesk.com/web-utils/conversion-web-analytics-utils/main.js',
  prd: 'https://swc.autodesk.com/web-utils/conversion-web-analytics-utils/main.js',
};

let cjsScriptPromise;
let cjsInitializationPromise;

const getCjsEnvironment = (env) => (env === 'prd' ? 'prd' : 'stg');

export const loadCjsScript = (env) => {
  if (window.CjsTracker?.init) {
    return Promise.resolve(window.CjsTracker);
  }

  if (cjsScriptPromise) {
    return cjsScriptPromise;
  }

  cjsScriptPromise = new Promise((resolve, reject) => {
    const cjsEnv = getCjsEnvironment(env);
    const existingScript = document.querySelector(`script[${CJS_SCRIPT_ATTRIBUTE}]`);
    const script = existingScript || document.createElement('script');
    let timeoutId;

    const cleanup = () => {
      window.clearTimeout(timeoutId);
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
    };

    const handleLoad = () => {
      cleanup();
      if (window.CjsTracker?.init) {
        resolve(window.CjsTracker);
      } else {
        reject(new Error('CJS SDK loaded without exposing CjsTracker'));
      }
    };

    const handleError = () => {
      cleanup();
      reject(new Error(`Failed to load CJS SDK from ${CJS_SCRIPT_URLS[cjsEnv]}`));
    };

    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);

    timeoutId = window.setTimeout(() => {
      cleanup();
      reject(new Error('Timed out loading CJS SDK'));
    }, CJS_SCRIPT_TIMEOUT_MS);

    if (!existingScript) {
      script.setAttribute(CJS_SCRIPT_ATTRIBUTE, cjsEnv);
      script.src = CJS_SCRIPT_URLS[cjsEnv];
      script.defer = true;
      document.head.appendChild(script);
    }
  });

  return cjsScriptPromise;
};

export const initializeCjs = ({ adp, env, productId, pageLocale }) => {
  if (!cjsInitializationPromise) {
    cjsInitializationPromise = loadCjsScript(env).then((CjsTracker) =>
      CjsTracker.init(adp)
        .setEnv(getCjsEnvironment(env))
        .trackClickElements()
        .defaultEventAttributes({ event_generator: 'profile-app' })
        .defaultEventData({
          page: {
            page_category: 'account',
            page_locale: pageLocale || 'en_US',
          },
        })
        .load({ id: productId })
    );
  }

  return cjsInitializationPromise;
};
